<script>
/**
 * ****************************************************************************
 * @description     :   Main component for popup FIL_030
 * @created at      :   2026/02/02
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import store from '@/store';
import template from './template.html';
import { mapState, mapMutations, mapActions } from 'vuex';
import PopupFIL030 from '@/views/popupSearch/PopupFIL030/store';
import helpers from '@/utils/helpers';

var PopupFIL030Index = {
    template: template,
    props: {
        onSelected: Function,
        id: String,
        initData: [String, Number, Object],
        isShowFooter: Boolean
    },
    beforeCreate() {
        if (!store.hasModule('PopupFIL030')) {
            store.registerModule('PopupFIL030', PopupFIL030);
        }
    },
    created() {
        this.onInitScreen();
        this.applyInitData();
        this.onSearchItem();
    },
    data() {
        return {};
    },
    emits: ['close', 'onReferModelValue', 'onReferValueName', 'onReferOtherName'],
    computed: {
        ...mapState('PopupFIL030', ['listData', 'data', 'totalRows', 'msgNoData'])
    },
    methods: {
        ...mapMutations('app', ['showHeaderError', 'showModalMessage']),
        ...mapActions('PopupFIL030', ['searchFil030Info']),
        ...mapMutations('PopupFIL030', ['resetDataInit', 'setPageNavigation', 'setPageNo']),
        applyInitData() {
            if (this.initData && typeof this.initData === 'object') {
                if (this.initData.company_cd !== undefined) {
                    this.data.company_cd = this.initData.company_cd;
                }
            } else if (this.initData !== undefined && this.initData !== null) {
                this.data.company_cd = this.initData;
            }
        },
        onSearchItem() {
            this.setPageNavigation({
                currentPage: 1,
                perPage: this.data.pageSize
            });
            this.searchFil030Info(this.data);
        },
        changeCurrentPage(data) {
            this.data.pageNo = data.currentPage;
            this.data.pageSize = data.perPage;
            this.searchFil030Info(this.data);
        },
        onInitScreen() {
            helpers.removeAllRequireInput();
            this.resetDataInit();
        },
        chooseItem(item) {
            this.$emit('onReferModelValue', item.staff_id);
            this.$emit('onReferValueName', item.staff_name);
            this.$emit('onReferOtherName', item.office_name);
            this.$emit('close');
        }
    }
};
export default PopupFIL030Index;
</script>

<style lang="scss">
@use '@/assets/scss/common/popup.scss' as *;
</style>
